
const digest = '648e4ca6ab5a1fccdabfe1b04eddd94ddfe3f04e8de657670ae0323bfbfc590c';
const classes = {"wrapper":"_wrapper_1s2af_1","input":"_input_1s2af_6","suffix":"_suffix_1s2af_38","prefix":"_prefix_1s2af_47","withPrefix":"_withPrefix_1s2af_56","withSuffix":"_withSuffix_1s2af_60","errorMessage":"_errorMessage_1s2af_64","invalid":"_invalid_1s2af_70"};
const css = `._wrapper_1s2af_1 {
  position: relative;
  display: flex;
}

._input_1s2af_6 {
  width: -webkit-fill-available;
  border: 1px solid #e2e5ed;
  min-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
  flex: 1;
}
._input_1s2af_6:disabled {
  background-color: #f3f3f3;
  opacity: 1;
}
._input_1s2af_6:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._input_1s2af_6[type=number]::-webkit-outer-spin-button, ._input_1s2af_6[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}
._input_1s2af_6[type=number] {
  -moz-appearance: textfield;
}

._suffix_1s2af_38 {
  font-family: Rubik, "sans-serif";
  position: absolute;
  font-size: 14px;
  color: #1665d8;
  right: 25px;
  bottom: 17px;
}

._prefix_1s2af_47 {
  left: 20px;
  font-family: Rubik, "sans-serif";
  position: absolute;
  font-size: 14px;
  color: #1665d8;
  bottom: 17px;
}

._withPrefix_1s2af_56 {
  padding-left: 35px !important;
}

._withSuffix_1s2af_60 {
  padding-right: 35px !important;
}

._errorMessage_1s2af_64 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: #d81616;
}

._invalid_1s2af_70 {
  border-color: #d81616 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  